import React, { Fragment } from "react";
import styled from "styled-components";
import { Button, Grid } from "@material-ui/core";
import { CompareArrows, Functions, Apps } from "@material-ui/icons";

const NewButton = styled(Button)`
  && {    
    margin-left:4px;
    padding: 8px 8px 8px 2px;
    border-radius:0;
    color: #2196F3;
    background:none;
  }
  && span {
    margin-left:8px;    
    margin-right:8px;
  }
  &&:hover {
    background:#f6f6f6;
  }
`;
export const VerticalDivider = styled.span`  
  height: 24px;
  border-right: 1px solid #cccccc;
  margin-left:4px;
`;
export const CompareQuotes = props => (
  <NewButton variant="contained" onClick={props.onClick}>
    <CompareArrows />
    <span>COMPARE</span>
  </NewButton>
);

export const CombineQuotes = props => (
  <NewButton variant="contained" onClick={props.onClick}>
    <Functions />
    <span>COMBINE QUOTES</span>
  </NewButton>
);

export const AnalysisButton = props => (
  <NewButton variant="contained" onClick={props.onClick}>
    <Apps />
    <span>ANALYSIS</span>
  </NewButton>
);
